const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);
const CONSOLE_METHODS = ['log', 'info', 'warn', 'error', 'debug'] as const;

type ConsoleMethod = (typeof CONSOLE_METHODS)[number];

const originalConsole = CONSOLE_METHODS.reduce((methods, method) => {
  methods[method] = console[method].bind(console);
  return methods;
}, {} as Record<ConsoleMethod, (...args: unknown[]) => void>);

const isLocalhost = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const { hostname } = window.location;

  return LOCALHOST_HOSTNAMES.has(hostname) || hostname.endsWith('.localhost');
};

const runOnLocalhost = (method: ConsoleMethod, args: unknown[]): void => {
  if (!isLocalhost()) {
    return;
  }

  originalConsole[method](...args);
};

export const patchConsoleForLocalhost = (): void => {
  CONSOLE_METHODS.forEach((method) => {
    console[method] = (...args: unknown[]) => runOnLocalhost(method, args);
  });
};

export const logger = {
  log: (...args: unknown[]): void => runOnLocalhost('log', args),
  info: (...args: unknown[]): void => runOnLocalhost('info', args),
  warn: (...args: unknown[]): void => runOnLocalhost('warn', args),
  error: (...args: unknown[]): void => runOnLocalhost('error', args),
  debug: (...args: unknown[]): void => runOnLocalhost('debug', args),
};

export const logToConsole = logger.log;

patchConsoleForLocalhost();
